import { Helmet } from "react-helmet-async";

export const MerchantReturnPolicySchema = () => {
  const returnPolicySchema = {
    "@context": "https://schema.org",
    "@type": "MerchantReturnPolicy",
    "@id": "https://www.aureum7trading.com/return-policy",
    "applicableCountry": ["ES", "DE", "FR", "IT", "GB"],
    "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
    "merchantReturnDays": 14,
    "returnMethod": "ReturnByMail",
    "returnFees": "https://schema.org/RestockingFees",
    "restockingFee": {
      "@type": "MonetaryAmount",
      "currency": "EUR",
      "value": "0"
    },
    "returnPolicySeasonalOverride": [],
    "itemCondition": "https://schema.org/NewCondition",
    "refundType": "https://schema.org/FullRefund",
    "itemDefectReturnFees": "https://schema.org/FreeReturn",
    "itemDefectReturnLabelSource": "https://schema.org/ReturnLabelDownloadAndPrint",
    "returnShippingFeesAmount": {
      "@type": "MonetaryAmount",
      "currency": "EUR",
      "value": "0"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(returnPolicySchema)}
      </script>
    </Helmet>
  );
};
